import { render, staticRenderFns } from "./AddBarTrendWidget.vue?vue&type=template&id=53720ca8"
import script from "./AddBarTrendWidget.vue?vue&type=script&lang=js"
export * from "./AddBarTrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports